import { createRef } from "react";

const state = {
    sections: 5,
    zoom: 75,
    top: createRef(),
    sectionIndex: 0
};

export default state;
